export default __webpack_public_path__ + "static/media/welc2.fa3fd73d.gif";